import styled from '@emotion/styled';
import WarningIcon from 'src/assets/icons/WarningIcon';
import { mainColors } from 'src/assets/colors';
import { fontSize } from 'src/assets/fonts-config';

export const CustomerSummary = styled('div', { label: 'CustomerSummary' })`
    padding: 0;
    font-size: 15px;
    height: 107px;
`;

export const CustomerSummaryContentWrapper = styled('div', { label: 'CustomerSummaryContentWrapper' })`
    display: flex;
    flex-flow: row nowrap;
`;

interface CustomerSummaryContentType {
    isActiveAccount: boolean;
}

export const CustomerSummaryContent = styled('div', { label: 'CustomerSummaryContent' })<CustomerSummaryContentType>`
    background: ${({ isActiveAccount }): string =>
        isActiveAccount ? mainColors.default.light : mainColors.status.error};
    display: flex;
    overflow: auto;
    padding: 10px;
`;

export const WarningInfo = styled('div', { label: 'WarningInfo' })`
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0 10px 0 0;
    align-items: center;
    width: 85px;
`;

export const WarningInfoText = styled('p', { label: 'WarningInfoText' })`
    font-size: 12px;
    line-height: 1.17;
    text-align: center;
    margin: 7px 0 0 0;
`;

export const WarningIconWrapper = styled(WarningIcon, { label: 'WarningIconWrapper' })`
    fill: #000;
`;

export const AuditBlockWrapper = styled('div', { label: 'AuditBlockWrapper' })`
    position: absolute;
    top: 476px;
    left: 14px;
    width: 197px;
`;

interface CustomerNotesType {
    label: string;
}

export const CustomerNotes = styled('div', { label: 'CustomerNotes' })<CustomerNotesType>`
    white-space: pre-wrap;
    word-wrap: break-word;
`;

interface CustomerSummaryBalanceType {
    failedWithdrawalsFundsEnabled: boolean;
}

export const CustomerSummaryBalance = styled('ul', { label: 'CustomerSummaryBalance' })<CustomerSummaryBalanceType>`
    list-style: none;
    background: #fff;
    padding: 5px 10px 4px;
    border: 1px solid #bbb;
    font-size: ${({ failedWithdrawalsFundsEnabled }): string =>
        failedWithdrawalsFundsEnabled ? fontSize.xSmall : fontSize.small};
    margin: 0 5px;
    line-height: 1;
    display: flex;
    flex-direction: column;
    gap: ${({ failedWithdrawalsFundsEnabled }): string => (failedWithdrawalsFundsEnabled ? '4px' : '6px')};
`;
